import script from "./payingFail.vue?vue&type=script&lang=ts&setup=true"
export * from "./payingFail.vue?vue&type=script&lang=ts&setup=true"

import "./payingFail.vue?vue&type=style&index=0&id=61d2790d&lang=less"

const __exports__ = script;

export default __exports__